import { DragOverlay as DndKitDragOverlay } from '@dnd-kit/core';
import { snapCenterToCursor } from '@dnd-kit/modifiers';
import { Portal } from '@headlessui/react';
import { FC, PropsWithChildren } from 'react';

const DragOverlay: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <Portal>
      <DndKitDragOverlay modifiers={[snapCenterToCursor]} dropAnimation={null}>
        {children}
      </DndKitDragOverlay>
    </Portal>
  );
};

export default DragOverlay;
